/**
 * date-fns locales. These live in node_modules, which is the one case Vite's dynamic-import-vars cannot handle at all — no glob it accepts may leave the project root.
 *
 * GENERATED FILE — do not edit by hand. It replaces a dynamic import whose path was built at
 * runtime, which webpack resolved through require.context and Rolldown cannot resolve at all.
 * Read by resources/js/base/i18n.js. Regenerate after adding or removing a file:
 *
 *     node scripts/generate-import-maps.mjs
 *
 * CI runs the same command with --check. Every value stays a thunk, so the modules are still
 * fetched on demand and still get a chunk each — only the discovery moved to build time.
 */

// Null prototype so an unlisted key reads as undefined instead of resolving to Object.prototype
// ('constructor', 'toString', …) and handing the caller something that is not a loader. webpack's
// context guarded its own map with hasOwnProperty for the same reason.
export const datepickerLocales = Object.assign(Object.create(null), {
    'af': () => import('date-fns/locale/af/index.js'),
    'ar': () => import('date-fns/locale/ar/index.js'),
    'ar-DZ': () => import('date-fns/locale/ar-DZ/index.js'),
    'ar-EG': () => import('date-fns/locale/ar-EG/index.js'),
    'ar-MA': () => import('date-fns/locale/ar-MA/index.js'),
    'ar-SA': () => import('date-fns/locale/ar-SA/index.js'),
    'ar-TN': () => import('date-fns/locale/ar-TN/index.js'),
    'az': () => import('date-fns/locale/az/index.js'),
    'be': () => import('date-fns/locale/be/index.js'),
    'be-tarask': () => import('date-fns/locale/be-tarask/index.js'),
    'bg': () => import('date-fns/locale/bg/index.js'),
    'bn': () => import('date-fns/locale/bn/index.js'),
    'bs': () => import('date-fns/locale/bs/index.js'),
    'ca': () => import('date-fns/locale/ca/index.js'),
    'cs': () => import('date-fns/locale/cs/index.js'),
    'cy': () => import('date-fns/locale/cy/index.js'),
    'da': () => import('date-fns/locale/da/index.js'),
    'de': () => import('date-fns/locale/de/index.js'),
    'de-AT': () => import('date-fns/locale/de-AT/index.js'),
    'el': () => import('date-fns/locale/el/index.js'),
    'en-AU': () => import('date-fns/locale/en-AU/index.js'),
    'en-CA': () => import('date-fns/locale/en-CA/index.js'),
    'en-GB': () => import('date-fns/locale/en-GB/index.js'),
    'en-IE': () => import('date-fns/locale/en-IE/index.js'),
    'en-IN': () => import('date-fns/locale/en-IN/index.js'),
    'en-NZ': () => import('date-fns/locale/en-NZ/index.js'),
    'en-US': () => import('date-fns/locale/en-US/index.js'),
    'en-ZA': () => import('date-fns/locale/en-ZA/index.js'),
    'eo': () => import('date-fns/locale/eo/index.js'),
    'es': () => import('date-fns/locale/es/index.js'),
    'et': () => import('date-fns/locale/et/index.js'),
    'eu': () => import('date-fns/locale/eu/index.js'),
    'fa-IR': () => import('date-fns/locale/fa-IR/index.js'),
    'fi': () => import('date-fns/locale/fi/index.js'),
    'fr': () => import('date-fns/locale/fr/index.js'),
    'fr-CA': () => import('date-fns/locale/fr-CA/index.js'),
    'fr-CH': () => import('date-fns/locale/fr-CH/index.js'),
    'fy': () => import('date-fns/locale/fy/index.js'),
    'gd': () => import('date-fns/locale/gd/index.js'),
    'gl': () => import('date-fns/locale/gl/index.js'),
    'gu': () => import('date-fns/locale/gu/index.js'),
    'he': () => import('date-fns/locale/he/index.js'),
    'hi': () => import('date-fns/locale/hi/index.js'),
    'hr': () => import('date-fns/locale/hr/index.js'),
    'ht': () => import('date-fns/locale/ht/index.js'),
    'hu': () => import('date-fns/locale/hu/index.js'),
    'hy': () => import('date-fns/locale/hy/index.js'),
    'id': () => import('date-fns/locale/id/index.js'),
    'is': () => import('date-fns/locale/is/index.js'),
    'it': () => import('date-fns/locale/it/index.js'),
    'it-CH': () => import('date-fns/locale/it-CH/index.js'),
    'ja': () => import('date-fns/locale/ja/index.js'),
    'ja-Hira': () => import('date-fns/locale/ja-Hira/index.js'),
    'ka': () => import('date-fns/locale/ka/index.js'),
    'kk': () => import('date-fns/locale/kk/index.js'),
    'km': () => import('date-fns/locale/km/index.js'),
    'kn': () => import('date-fns/locale/kn/index.js'),
    'ko': () => import('date-fns/locale/ko/index.js'),
    'lb': () => import('date-fns/locale/lb/index.js'),
    'lt': () => import('date-fns/locale/lt/index.js'),
    'lv': () => import('date-fns/locale/lv/index.js'),
    'mk': () => import('date-fns/locale/mk/index.js'),
    'mn': () => import('date-fns/locale/mn/index.js'),
    'ms': () => import('date-fns/locale/ms/index.js'),
    'mt': () => import('date-fns/locale/mt/index.js'),
    'nb': () => import('date-fns/locale/nb/index.js'),
    'nl': () => import('date-fns/locale/nl/index.js'),
    'nl-BE': () => import('date-fns/locale/nl-BE/index.js'),
    'nn': () => import('date-fns/locale/nn/index.js'),
    'oc': () => import('date-fns/locale/oc/index.js'),
    'pl': () => import('date-fns/locale/pl/index.js'),
    'pt': () => import('date-fns/locale/pt/index.js'),
    'pt-BR': () => import('date-fns/locale/pt-BR/index.js'),
    'ro': () => import('date-fns/locale/ro/index.js'),
    'ru': () => import('date-fns/locale/ru/index.js'),
    'sk': () => import('date-fns/locale/sk/index.js'),
    'sl': () => import('date-fns/locale/sl/index.js'),
    'sq': () => import('date-fns/locale/sq/index.js'),
    'sr': () => import('date-fns/locale/sr/index.js'),
    'sr-Latn': () => import('date-fns/locale/sr-Latn/index.js'),
    'sv': () => import('date-fns/locale/sv/index.js'),
    'ta': () => import('date-fns/locale/ta/index.js'),
    'te': () => import('date-fns/locale/te/index.js'),
    'th': () => import('date-fns/locale/th/index.js'),
    'tr': () => import('date-fns/locale/tr/index.js'),
    'ug': () => import('date-fns/locale/ug/index.js'),
    'uk': () => import('date-fns/locale/uk/index.js'),
    'uz': () => import('date-fns/locale/uz/index.js'),
    'uz-Cyrl': () => import('date-fns/locale/uz-Cyrl/index.js'),
    'vi': () => import('date-fns/locale/vi/index.js'),
    'zh-CN': () => import('date-fns/locale/zh-CN/index.js'),
    'zh-HK': () => import('date-fns/locale/zh-HK/index.js'),
    'zh-TW': () => import('date-fns/locale/zh-TW/index.js'),
});

export default datepickerLocales;
